/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { ROUTES } from "../constants/constants";

export const isClassService = (service) => service?.is_class === true;

// First step after a class is picked: its add-ons, else date/time.
export const getClassStartRoute = (classItem, addonsEnabled) =>
  addonsEnabled && classItem.has_available_addons ? ROUTES.ADDONS : ROUTES.DATETIME;
